import api from './apiClient';

const performanceCycleApi = {
  getCycles: (params) => api.get('/performance/cycles', { params }),
  getCycleById: (id) => api.get(`/performance/cycles/${id}`),
  createCycle: (data) => api.post('/performance/cycles', data),
  updateCycle: (id, data) => api.put(`/performance/cycles/${id}`, data),
  deleteCycle: (id) => api.delete(`/performance/cycles/${id}`),
  startCycle: (id) => api.patch(`/performance/cycles/${id}/start`),
  endCycle: (id) => api.patch(`/performance/cycles/${id}/end`),
  pauseCycle: (id) => api.patch(`/performance/cycles/${id}/pause`),
  resumeCycle: (id) => api.patch(`/performance/cycles/${id}/resume`),
  getActiveCycle: () => api.get('/performance/cycles/active'),
  getCycleStats: (id) => api.get(`/performance/cycles/${id}/stats`),
  launchCycle: (id, data = {}) => api.post(`/performance/cycles/${id}/launch`, data)
};

export { performanceCycleApi };

